import { render, staticRenderFns } from "./SalemanMoneyData.vue?vue&type=template&id=95f5c4ba&scoped=true&"
import script from "./SalemanMoneyData.vue?vue&type=script&lang=js&"
export * from "./SalemanMoneyData.vue?vue&type=script&lang=js&"
import style0 from "./SalemanMoneyData.vue?vue&type=style&index=0&id=95f5c4ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f5c4ba",
  null
  
)

export default component.exports